<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="32" class="main-logo">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="36" class="main-logo">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light.svg" alt="" height="32" class="main-logo">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="36" class="main-logo">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" [ngClass]="{ 'd-none': theme === 'horizontal' }" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>

    <div class="d-flex">
      <!-- Planning Center Sync Status -->
      <div class="d-none d-lg-inline-block ms-1" *ngIf="showPcoSyncStatus">
        <div class="d-flex align-items-center" style="height: 70px;">
          <span class="badge rounded-pill px-3 py-2" [ngClass]="{
            'bg-warning': pcoSyncStatus === 'syncing',
            'bg-danger': pcoSyncStatus === 'error'
          }" [title]="pcoSyncStatus === 'error' ? ('Planning Center sync error: ' + (pcoSyncError || 'An error occurred while syncing data from Planning Center. Please try refreshing the sync from Organization Settings.')) : 'Syncing people, lists, groups, teams, and service types from Planning Center. This may take several minutes for large organizations.'" style="cursor: help;">
            <i class="bx" [ngClass]="{
              'bx-sync bx-spin': pcoSyncStatus === 'syncing',
              'bx-error-circle': pcoSyncStatus === 'error'
            }"></i>
            <span class="ms-1">{{ pcoSyncStatus === 'syncing' ? 'PCO Syncing' : 'PCO Sync Error' }}</span>
          </span>
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <!-- WhatsApp Messaging Limits -->
      <div class="dropdown d-none d-lg-inline-block ms-1" dropdown *ngIf="messagingLimits.length > 0">
        <button type="button" class="btn header-item noti-icon" id="page-header-whatsapp-limits" dropdownToggle>
          <i class="bx bxl-whatsapp" [ngClass]="{
            'text-danger': messagingLimitAlertsCount > 0,
            'text-success': messagingLimitAlertsCount === 0
          }"></i>
          <span class="badge bg-danger rounded-pill" *ngIf="messagingLimitAlertsCount > 0">{{ messagingLimitAlertsCount }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" *dropdownMenu>
          <div class="p-3 border-bottom">
            <h6 class="m-0 font-size-15">WhatsApp Messaging Limits</h6>
          </div>
          <ngx-simplebar style="position: relative; max-height: 300px;">
            <div *ngIf="loadingLimits" class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div *ngIf="!loadingLimits && messagingLimits.length === 0" class="text-center py-3">
              <i class="bx bxl-whatsapp font-size-24 text-muted"></i>
              <p class="text-muted mt-2 mb-0">No limits available</p>
            </div>
            <div *ngFor="let limit of messagingLimits; trackBy: trackByPhoneNumberId" class="text-reset notification-item border-bottom">
              <div class="d-flex align-items-start p-3">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-sm">
                    <span class="avatar-title rounded-circle font-size-18" style="background-color: #25D366; color: white;">
                      <i class="bx bxl-whatsapp"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                  <h6 class="mb-1 font-size-13">{{ limit.displayPhoneNumber }}</h6>
                  <p class="mb-2 text-muted font-size-11" *ngIf="limit.verifiedName">{{ limit.verifiedName }}</p>
                  <span class="badge badge-soft-info font-size-11 mb-2">{{ getFormattedTierName(limit.limitTier) }}</span>
                  <div class="row g-2 mt-1">
                    <div class="col-6">
                      <div class="text-muted font-size-11">Sent</div>
                      <div class="font-size-13 fw-medium text-dark">{{ limit.messagesSent || 0 }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted font-size-11">Remaining</div>
                      <div class="font-size-13 fw-medium" [ngClass]="{
                        'text-success': limit.messagesRemaining === -1 || limit.messagesRemaining > (limit.limitValue * 0.5),
                        'text-warning': limit.messagesRemaining > 0 && limit.messagesRemaining <= (limit.limitValue * 0.5) && limit.messagesRemaining > (limit.limitValue * 0.2),
                        'text-danger': limit.messagesRemaining >= 0 && limit.messagesRemaining <= (limit.limitValue * 0.2)
                      }">{{ limit.messagesRemaining === -1 ? 'Unlimited' : limit.messagesRemaining }}</div>
                    </div>
                  </div>
                  <div class="mt-2" *ngIf="limit.messagesRemaining !== -1">
                    <div class="progress" style="height: 6px;">
                      <div class="progress-bar" role="progressbar" 
                           [style.width.%]="(limit.messagesRemaining / limit.limitValue) * 100"
                           [ngClass]="{
                             'bg-success': limit.messagesRemaining > (limit.limitValue * 0.5),
                             'bg-warning': limit.messagesRemaining <= (limit.limitValue * 0.5) && limit.messagesRemaining > (limit.limitValue * 0.2),
                             'bg-danger': limit.messagesRemaining <= (limit.limitValue * 0.2)
                           }">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ngx-simplebar>
          <div class="p-2 border-top" *ngIf="!isConversationsOnly">
            <a class="btn btn-sm btn-link font-size-13 text-center w-100" (click)="navigateToSettings()">
              <i class="mdi mdi-cog me-1"></i> Manage WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" dropdownToggle>
          <i class="bx bx-bell" [class.bx-tada]="unreadCount > 0"></i>
          <span *ngIf="unreadCount > 0" class="badge bg-danger rounded-pill">{{ unreadCount }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown" *dropdownMenu>
          <div class="p-3 pb-0">
            <div class="row align-items-center mb-2">
              <div class="col">
                <h6 class="m-0">Notifications</h6>
              </div>
              <div class="col-auto">
                <a href="#" (click)="$event.preventDefault(); markAllNotificationsAsRead()" class="small text-primary me-2" *ngIf="unreadCount > 0">Mark all as read</a>
                <a href="#" (click)="$event.preventDefault(); clearAllNotifications()" class="small text-danger" *ngIf="notifications.length > 0">Clear all</a>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between border-top pt-2 mb-2"
                 *ngIf="pushSupported">
              <div class="me-2">
                <label class="mb-0 font-size-13" for="pushToggle">Alerts on this device</label>
                <div class="text-muted font-size-11">{{ pushHint }}</div>
              </div>
              <div class="form-check form-switch mb-0">
                <input class="form-check-input" type="checkbox" role="switch" id="pushToggle"
                       [checked]="pushEnabled"
                       [disabled]="pushBusy || pushBlocked"
                       (click)="$event.stopPropagation()"
                       (change)="togglePush($event)">
              </div>
            </div>
            <ul class="nav nav-tabs nav-tabs-custom mb-0" role="tablist">
              <li class="nav-item">
                <a class="nav-link" [class.active]="notificationTab === 'unread'" href="#" (click)="$event.preventDefault(); notificationTab = 'unread'; $event.stopPropagation()">Unread <span class="badge bg-danger rounded-pill ms-1" *ngIf="unreadCount > 0">{{ unreadCount }}</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="notificationTab === 'all'" href="#" (click)="$event.preventDefault(); notificationTab = 'all'; $event.stopPropagation()">All</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="notificationTab === 'read'" href="#" (click)="$event.preventDefault(); notificationTab = 'read'; $event.stopPropagation()">Read</a>
              </li>
            </ul>
          </div>
          <ngx-simplebar style="position: relative; max-height: 400px;">
            <div *ngIf="filteredNotifications.length === 0" class="text-center p-4">
              <i class="bx bx-bell-off font-size-24 text-muted"></i>
              <p class="text-muted mt-2">{{ notificationTab === 'unread' ? 'No unread notifications' : notificationTab === 'read' ? 'No read notifications' : 'No notifications' }}</p>
            </div>
            <div *ngFor="let notification of filteredNotifications; trackBy: trackByNotificationId" 
               class="text-reset notification-item d-flex align-items-start"
               [class.bg-light]="!notification.isRead">
              <div class="flex-grow-1" style="cursor: pointer;" (click)="onNotificationClick(notification)">
                <div class="d-flex">
                  <div class="avatar-xs me-3 flex-shrink-0">
                    <span class="avatar-title rounded-circle font-size-16 d-flex align-items-center justify-content-center"
                          [ngClass]="'bg-' + notification.iconColor"
                          style="width: 2.5rem; height: 2.5rem;">
                      <i [class]="'bx ' + notification.icon"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-1">{{ formatNotificationText(notification.title) }}</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">{{ formatNotificationText(notification.message) }}</p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ getRelativeTime(notification.createdAt) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0 ms-2 dropdown" dropdown>
                <button class="btn btn-sm btn-light" type="button" dropdownToggle (click)="$event.stopPropagation()">
                  <i class="mdi mdi-dots-vertical"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                  <a class="dropdown-item" href="#" (click)="$event.preventDefault(); toggleNotificationReadStatus(notification, $event)" *ngIf="notification.isRead">
                    <i class="mdi mdi-email-outline me-2"></i>Mark as unread
                  </a>
                  <a class="dropdown-item" href="#" (click)="$event.preventDefault(); toggleNotificationReadStatus(notification, $event)" *ngIf="!notification.isRead">
                    <i class="mdi mdi-email-open-outline me-2"></i>Mark as read
                  </a>
                  <a class="dropdown-item text-danger" href="#" (click)="$event.preventDefault(); deleteNotification(notification, $event)">
                    <i class="mdi mdi-delete-outline me-2"></i>Delete
                  </a>
                </div>
              </div>
            </div>
          </ngx-simplebar>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button type="button" class="btn header-item" dropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" [src]="userPhotoURL" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{ userName }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- User info at top -->
          <div class="px-3 py-2">
            <p class="text-muted mb-0 font-size-13"><strong>{{ userName }}</strong></p>
            <p class="text-muted mb-0 font-size-12">{{ userEmail }}</p>
            <p class="text-muted mb-0 font-size-11 mt-1" *ngIf="organizationName">
              <i class="bx bxs-building me-1"></i>{{ organizationName }}
            </p>
            <p class="mb-0 mt-2" *ngIf="userRole">
              <span class="badge" [ngClass]="{
                'badge-soft-danger': userRole === 'Owner',
                'badge-soft-primary': userRole === 'Administrator',
                'badge-soft-success': userRole === 'Editor',
                'badge-soft-warning': userRole === 'Sender',
                'badge-soft-secondary': userRole === 'Viewer',
                'badge-soft-info': userRole === 'Support Staff'
              }">{{ userRole }}</span>
            </p>
          </div>
          <div class="dropdown-divider"></div>
          <!-- The way between the two halves of the app. A Solenex
               administrator is an ordinary Echo user as well, so they need to
               move between their own organisation and the console without
               signing out.

               An href rather than a routerLink: the console now lives on its
               own origin, so the router cannot reach it. Hidden entirely when
               no console URL is configured, which is the case outside
               production. -->
          <a class="dropdown-item" *ngIf="isPlatformAdmin() && adminConsoleUrl"
             [href]="adminConsoleUrl" target="_blank" rel="noopener">
            <i class="bx bx-shield-quarter font-size-16 align-middle me-1"></i>
            Solenex Admin
          </a>
          <div class="dropdown-divider" *ngIf="isPlatformAdmin() && adminConsoleUrl"></div>
          <!-- Profile: open Planning Center profile in new tab. Only for orgs
               that have Planning Center — there is nowhere to send anyone else. -->
          <a class="dropdown-item" *ngIf="hasPco" [href]="planningCenterProfileUrl" target="_blank" rel="noopener">
            <i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}
          </a>
          <!-- Wallet option removed -->
          <div class="dropdown-divider"></div>
          <!-- Token Refresh Button -->
          <a class="dropdown-item text-danger" href="#" (click)="$event.preventDefault(); logout()">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}
          </a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">
          <i class="bx bx-cog"></i>
        </button>
      </div>

    </div>
  </div>
</header>

<!-- Full-screen logout overlay -->
<div class="logout-overlay" *ngIf="showLogoutOverlay">
  <div class="logout-overlay-content">
    <div class="logout-spinner">
      <i class="bx bx-loader-alt spinning"></i>
    </div>
    <h4 class="logout-text">Signing Out...</h4>
    <p class="logout-subtext">Please wait while we securely sign you out</p>
  </div>
</div>